
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-hiring-platform",
      function () {
        return require("private-next-pages/ai-hiring-platform.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-hiring-platform"])
      });
    }
  